<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <span
    v-tooltip.top="{ content: description, delay: 200 }"
    class="badge"
    :class="classBadge"
    @click="copyToClipboard(id, onCopyID)"
    >#{{ id }}</span
  >
</template>

<script type="text/babel">
  import { copyToClipboard } from '@/globals';
  import UserNotifications from '@/utils/UserNotifications';
  import i18n from '@/vueI18n';

  export default {
    name: 'EntityIdBadge',
    props: {
      id: { type: String },
      classBadge: {
        type: String,
        default: 'badge-info',
      },
      description: {
        type: String,
        default: () => i18n.global.t('messages.clickToCopyTheIDToTheClipboard'),
      },
    },
    methods: {
      onCopyID() {
        UserNotifications.success({
          title: i18n.global.t('messages.copyID'),
          message: i18n.global.t('messages.copiedIdToClipboard'),
        });
      },
      copyToClipboard(text, successCallback) {
        copyToClipboard(text, successCallback);
      },
    },
  };
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  @use '@/styles/variables' as *;

  .badge {
    cursor: pointer;
  }
</style>
